import type { FC, ReactNode } from "react";

type H4Props = {
  children: ReactNode;
};

const H4: FC<H4Props> = ({ children }) => {
  return (
    <h3 className="text-sm font-semibold">{children}</h3>
  );
};

export default H4;
